import { QUOTE_URL } from "constants/common.constants";
import { EMPTY_STATE_CUBE } from "constants/products.constants";

type ComingSoonPaneProps = {
  title: string;
  text: string;
};

/**
 * What a section renders before it has a page — today the Shipments sub-items
 * still waiting on theirs. Naming the section beats a blank screen.
 */
export const ComingSoonPane = ({ title, text }: ComingSoonPaneProps) => (
  <div className="pc-pane">
    <div className="pcx">
      <div className="pcx__top">
        <div>
          <div className="pcx__h">{title}</div>
          <p className="pcx__sub">Not available yet.</p>
        </div>
      </div>

      <div className="pc-empty">
        <img className="pc-empty__cube" src={EMPTY_STATE_CUBE} alt="" width={96} height={96} />
        <div className="pc-empty__h">Coming soon</div>
        <p className="pc-empty__t">{text}</p>
        <div className="pc-empty__acts">
          <a className="pcbtn" href={QUOTE_URL} target="_blank" rel="noopener noreferrer">
            Talk to us about it
          </a>
        </div>
      </div>
    </div>
  </div>
);
